<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img"  @click="goInfo" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="solve head-label" style="position: relative;">
            <!-- <div style="text-align: center;" class="font_size_25">
                赋能家政企业全域增长，打造专业化数字新标杆
            </div> -->
            <div class="font_size_26">为什么选择临里好家政系统</div>
            <!-- <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d25e845cdf3.png" alt="" style="width: 220px;" class="imgs"> -->
        </div>
        <div class="topBox1" style="margin-bottom: 50px;">
            <div class="topBox1_left">
                <div class="text1">您是否遇到这些问题</div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>拉新拓客难，客单量少</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>家政用工难，成本高</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>传统手工作业时，费时、费力、废财</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>传统家政软件总是感觉场景不够用，无法满足需求</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>养技术团队成本太高，不知从何下手</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>传统营销方式效率太低少</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>服务难监管、客户不信任、服务人员跳单</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202882d5502.png" style="width: 18px;" alt="">
                    <div>异业合作切入没有思路，社区融合、上下游产业链管理没有工具</div>
                </div>
            </div>
            <div class="topBox1_right">
                <div class="text1">我们能为您做什么</div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>丰富的营销工具，轻松拉新拓客</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>灵活就业渠道，轻松搞定</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>SaaS智能管理系统，助您轻松管人、管事、管财</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>万能工单、定制化工单流程轻松帮您解决</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>系统开发、功能场景迭代升级，通通我们来做</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>分销分享社区活动模式，提高销售效率</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>全流程服务监管、完善的信用体系支撑、服务跳单预警</div>
                </div>
                <div class="text2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69202ca461aa4.png" style="width: 18px;" alt="">
                    <div>多样化异业合作模式、专属社区融合、异业合作工具帮你轻松启航</div>
                </div>
            </div>
        </div>
       <div>
            <div class="solve head-label" style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 20px;">盈利模型丰富</div>
                <div class="font_size_31">重构盈利模型，多元收益方案，总有一款适合您 <div class="font_size_32">让盈利如此简单</div></div>
            </div>
            <div class="topBox2">
                <div class="topBox2_left">
                    <div class="topBox2_left_box">
                        <div class="text3">僵尸会员激活</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">渠道拓客</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">异业合作</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">社区融合</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">上下产业链合作</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">临里共享帮手</div>
                        <div class="text4">盈利模式</div>
                    </div>
                </div>
                <div class="topBox2_center">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251125/69251323813ed.png" alt="" style="width: 580px;margin: 0 50px;">
                </div>
                <div class="topBox2_right">
                    <div class="topBox2_left_box">
                        <div class="text3">节假日营销</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">新会员拓客</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">包年套餐</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">分级零售</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">灵活就业会员</div>
                        <div class="text4">盈利模式</div>
                    </div>
                    <div class="topBox2_left_box">
                        <div class="text3">临里培训</div>
                        <div class="text4">盈利模式</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bgBox">
            <div class="bgBox_title">18大功能  全面覆盖家政及增值链运营场景</div>
            <div class="bgBox_tab">
                <div v-for="(item,index) in tabsList" :key="index" class="tab_item">{{ item }}</div>
            </div>
        </div>
        <div>
            <div class="solve head-label" style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 20px;">管理您的家政</div>
                <div class="font_size_31">全链路管理，降低成本，多端管理提升效率 <div class="font_size_32">让家政管理变得轻松简单</div></div>
            </div>
            <div class="bgBlue">
                <div class="bgBlue_item">客户下单</div>
                <div class="bgBlue_item">系统派单</div>
                <div class="bgBlue_item">员工接单</div>
                <div class="bgBlue_item">上门服务</div>
                <div class="bgBlue_item">拍照/验收</div>
                <div class="bgBlue_item">服务评价</div>
                <div class="bgBlue_item">订单完成</div>
                <div class="bgBlue_item">售后回访</div>
            </div>
        </div>
        <div class="phoneBox">
            <div class="phoneBox_title">
                <div class="phoneBox_title_text" :class="phoneType == 3 ? 'changeY' : ''" @click="phoneType = 3">全场景管理</div>
                <div class="phoneBox_title_text" :class="phoneType == 1 ? 'changeY' : ''" @click="phoneType = 1">拓客工具</div>
                <div class="phoneBox_title_text" :class="phoneType == 2 ? 'changeY' : ''" @click="phoneType = 2">多端管理</div>
            </div>
            <div class="phoneImgBox1" v-if="phoneType == 3">
                <div class="phone_left">
                    <div v-for="(item,index) in pagesList" @click="pagesIndex = index" :key="index" :class="pagesIndex == index ? 'phone_left_text1':'phone_left_text'">{{ item.title }}</div>
                </div>
                <div class="phone_right">
                    <img :src="pagesList[pagesIndex].url" style="width: 600px;" alt="">
                </div>
            </div>
            <div class="phoneImgBox" v-if="phoneType == 1">
                <div class="phoneCenters">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d3a3d1bae98.png" class="phoneImg" alt="">
                    <div>活动模板</div>
                </div>
                <div class="phoneCenters">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d3a41720af2.png" class="phoneImg" alt="">
                    <div>营销活动</div>
                </div>
                <div class="phoneCenters">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d3a4269f29a.png" class="phoneImg" alt="">
                    <div>好物分享</div>
                </div>
            </div>
            <div class="phoneImgBox" v-if="phoneType == 2">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4f4c5ad7c6.png" style="width: 40em;" alt="">
            </div>
        </div>
        <div>
            <div class="solve head-label" style="position: relative;">
                <div class="font_size_26" style="margin: 60px 0;">全栈家政从业场景都适用</div>
            </div>
            <div class="imgFlex">
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f94e670387.png" class="imgFlex_item_img" alt="">
                    <div>家庭保洁</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f9634e25f8.png" class="imgFlex_item_img" alt="">
                    <div>家电清洗</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f964a6eeb9.png" class="imgFlex_item_img" alt="">
                    <div>清洗养护</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f965425ab1.png" class="imgFlex_item_img" alt="">
                    <div>保姆月嫂</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f9660b3429.png" class="imgFlex_item_img" alt="">
                    <div>收纳整理</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251215/693f596b43fbf.png" class="imgFlex_item_img" alt="">
                    <div>护工护理</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f968ef20a0.png" class="imgFlex_item_img" alt="">
                    <div>搬家搬货</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f969988335.png" class="imgFlex_item_img" alt="">
                    <div>消杀甲醛</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f96a2c4259.png" class="imgFlex_item_img" alt="">
                    <div>安装维修</div>
                </div>
                <div class="imgFlex_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692f96abcca10.png" class="imgFlex_item_img" alt="">
                    <div>工程保洁</div>
                </div>
            </div>
        </div>
        <div class="operationBox" style="position: relative;margin-top: 80px;">
            <div style="margin-left: 220px;" class="font_size_28">
                四步上线，轻松开启智能管理时代
            </div>
            <div class="operationInfo">
                <div style="width: 20%;">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4d5a5e97c7.png" style="width: 65px;height: 65px;" alt="">
                    <div class="operationTitle">注册试用</div>
                    <div class="operationContent">免费开通账号，即刻体验。</div>
                </div>
                <div style="width: 20%;">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4def84ebb4.png" style="width: 65px;height: 65px;" alt="">
                    <div class="operationTitle">配置系统</div>
                    <div class="operationContent">录入员工、服务项目等信息（我们提供指导）。</div>
                </div>
                <div style="width: 20%;">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4df0d667d6.png" style="width: 65px;height: 65px;" alt="">
                    <div class="operationTitle">发布小程序</div>
                    <div class="operationContent">选择模板，一键生成您的线上门店。</div>
                </div>
                <div style="width: 20%;">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4df1c42c85.png" style="width: 65px;height: 65px;" alt="">
                    <div class="operationTitle">高效运营</div>
                    <div class="operationContent">开始接单、派单，使用营销工具拉新增长。</div>
                </div>
            </div>
        </div>
        <div style="margin: 80px 0;">
            <div class="solve head-label" style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 20px;">做家政小程序、建本地家政服务平台 就用临里好系统</div>
                <div class="font_size_31">立即咨询 领取您的专属解决方案</div>
            </div>
            <div style="text-align: center;margin-top: 30px;">
                <el-button type="primary" style="font-size: 22px;" @click="goInfo">立即咨询</el-button>
            </div>
        </div>
        <div style="margin: 80px 0;">
            <div class="solve head-label" style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 50px;">合作伙伴</div>
            </div>
            <div style="display: flex;margin-top: 30px;flex-wrap: wrap;width: 85%;margin: auto;gap: 30px;justify-content: center;margin-top: 50px;">
                <div class="bottomFlex" v-for="(item,index) in companyList" :key="index">{{ item }}</div>
            </div>
        </div>

        <!-- ------------------------------------------ -->
        <!-- <div style="display: flex;align-items: center;justify-content: center;width: 90%;margin-left: 5%;gap: 25px;">
            <div v-for="(item, index) in bgList" :key="index" class="imgText" :style="'background-image: url(' + item.img + ');'">
                <div class="imgText_title">{{item.title}}</div>
                <div class="imgText_content">{{item.content}}</div>
            </div>
        </div> -->
       <!--  <div class="advantage">
            <div class="advantage_left">
                <div class="ad_left1">我们的优势</div>
                <div class="ad_left2">Our advantages</div>
                <img class="ad_left3" src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d343f2b4bfb.png" alt="">
            </div>
            <div class="advantage_right">
                <div class="ad_right1">
                    <div class="centers">
                        <div class="ad_right_text">智能运营管理</div>
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35e1101b84.png" style="width: 25px;margin: 15px 0;" alt="">
                    </div>
                     <div class="centers">
                        <div class="ad_right_text">裂变式营销中心</div>
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35e1101b84.png" style="width: 25px;margin: 15px 0;" alt="">
                    </div>
                     <div class="centers">
                        <div class="ad_right_text">服务人员信用体系</div>
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35e1101b84.png" style="width: 25px;margin: 15px 0;" alt="">
                    </div>
                     <div class="centers">
                        <div class="ad_right_text">智能工单派送</div>
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35e1101b84.png" style="width: 25px;margin: 15px 0;" alt="">
                    </div>
                </div>
                <div class="ad_right2">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35947418ef.png" style="width: 90%;" alt="">
                </div>
                <div class="ad_right1">
                    <div class="centers">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35fad12fd2.png" style="width: 25px;margin: 15px 0;" alt="">
                        <div class="ad_right_text">异业合作</div>
                    </div>
                     <div class="centers">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35fad12fd2.png" style="width: 25px;margin: 15px 0;" alt="">
                        <div class="ad_right_text">上下游链企业</div>
                    </div>
                     <div class="centers">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35fad12fd2.png" style="width: 25px;margin: 15px 0;" alt="">
                        <div class="ad_right_text">居民服务企业</div>
                    </div>
                     <div class="centers">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d35fad12fd2.png" style="width: 25px;margin: 15px 0;" alt="">
                        <div class="ad_right_text">多渠道拓客</div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- ------------------------------------------- -->
         <!-- <div class="solve head-label" style="position: relative;">
            <div style="text-align: center;color: #1773FF;margin-bottom: 80px;" class="font_size_25">
                SaaS赋能平台，全方位功能，为您的家政业务保驾护航
            </div>
        </div>
        <div class="tabsBox">
            <div class="tabsItem">
                <div class="tabsTitle">管理端</div>
                <div class="tabsInfo">
                    <div class="tabs">客户管理</div>
                    <div class="tabs">订单全流程管理</div>
                    <div class="tabs">财务管理</div>
                    <div class="tabs">分润分账管理</div>
                    <div class="tabs">企业管理</div>
                </div>
            </div>
            <div class="tabsItem">
                <div class="tabsTitle">社区端</div>
                <div class="tabsInfo">
                    <div class="tabs">服务人员管理</div>
                    <div class="tabs">异业合作</div>
                </div>
            </div>
        </div> -->
        <!-- ------------------------------------------- -->

        <!-- ------------------------------------------ -->
        <!-- <div class="staffs">
            <div style="text-align: center;color: #1773FF;" class="font_size_25">
                服务人员身份背调准确有保障
            </div>
            <div style="text-align: center;margin-bottom: 50px;" class="font_size_27">身份信用一键查询，不良信息一览无遗</div>
            <div class="flex1">
                <div class="staff_left">
                    <div class="staff_leftTop">
                        <div class="flex1">
                            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d3bbcdb6960.png" class="staff_icon" alt="">
                            <div style="font-size: 2.1em;">身份识别一键查询</div>
                        </div>
                        <div class="flex1">
                            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4916b0aa0e.png" class="staff_icon" alt="">
                            <div style="font-size: 2.1em;">一个列表轻松筛选，精准匹配</div>
                        </div>
                    </div>
                    <div class="staff_leftBottom">
                        <div class="flex1">
                            <div class="flex1" style="margin-right: 70px;">
                                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d49a5ea4f45.png" style="width: 1.5em;margin-right: 15px;" alt="">
                                <div style="font-size: 1.5em;">身份认证</div>
                            </div>
                            <div class="flex1" style="margin-right: 70px;">
                                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d49a5ea4f45.png" style="width: 1.5em;margin-right: 15px;" alt="">
                                <div style="font-size: 1.5em;">身份认证</div>
                            </div>
                        </div>
                        <div class="flex1">
                            <div class="flex1" style="margin-right: 70px;">
                                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d49a5ea4f45.png" style="width: 1.5em;margin-right: 15px;" alt="">
                                <div style="font-size: 1.5em;">身份认证</div>
                            </div>
                            <div class="flex1" style="margin-right: 70px;">
                                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d49a5ea4f45.png" style="width: 1.5em;margin-right: 15px;" alt="">
                                <div style="font-size: 1.5em;">身份认证</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="staff_right">
                    <div class="flex1">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4a2f3ac5f0.png" style="width: 14em;margin-right: 40px;" alt="">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4a478859bd.png" style="width: 14em;" alt="">
                    </div>
                </div>
            </div>
        </div> -->
        <!-- ------------------------------------------ -->
        <!-- <div class="customerBox" style="position: relative;">
            <div style="text-align: center;" class="font_size_28">
                他们正在使用【临里好家政系统】实现增长
            </div>
            <div class="flex1" style="justify-content: center;gap: 80px;margin-top: 100px;">
                <div class="customer_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4abf5e2cc8.png" style="width: 12em;" alt="">
                    <div class="customerTitle">建德阿姐家政公司</div>
                    <div class="customerContent">使用分销功能后，月新客增长40%</div>
                </div>
                <div class="customer_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4aec19e460.png" style="width: 11em;" alt="">
                    <div class="customerTitle" style="margin-top: 22px;">李阿姨保洁服务</div>
                    <div class="customerContent">使用系统后，派单效率提升60%，客户投诉率下降80%</div>
                </div>
            </div>
        </div> -->
        <!-- ------------------------------------------ -->

        <!-- <div class="cooperationBox">
            <div style="text-align: center;" class="font_size_25">
                合作伙伴
            </div>
            <div class="flex1" style="justify-content: center; gap: 25px;margin-top: 35px;">
                <div class="tabss">地区站点成功建设</div>
                <div class="tabss">杭州家政战略合作</div>
                <div class="tabss">沃尔玛积分合作</div>
                <div class="tabss">平安车险</div>
            </div>
        </div>
        <div class="bottomBg">
            <div class="bottomTitle">集成多重商业模式，助您轻松运营获利</div>
            <div class="bottomContent">免费注册，开启智能管理</div>
            <div class="bottomBtn">立即咨询</div>
        </div> -->

        <!-- ------------------------------------------ -->
        <!-- <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                特色功能
            </div>
        </div>
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[1].img" class="img_border" />
                        </div>
                        <div class="border_title">{{images[1].title}}</div>
                        <div class="border_content_one">{{images[1].content[0]}}</div>
                        <div class="border_content_two">{{images[1].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[2].img" class="img_border" />
                        </div>
                        <div class="border_title">{{images[2].title}}</div>
                        <div class="border_content_one">{{images[2].content[0]}}</div>
                        <div class="border_content_two">{{images[2].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[3].img" class="img_border" />
                        </div>
                        <div class="border_title">{{images[3].title}}</div>
                        <div class="border_content_one">{{images[3].content[0]}}</div>
                        <div class="border_content_two">{{images[3].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[4].img" class="img_border" />
                        </div>
                        <div class="border_title">{{images[4].title}}</div>
                        <div class="border_content_one">{{images[4].content[0]}}</div>
                        <div class="border_content_two">{{images[4].content[1]}}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div id="产品微观" class="head-label">
            <div style="text-align: center;" class="font_size_24">
                项目介绍
            </div>
        </div>
        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">{{products[0].title}}</div>
                            <div class="product_font_style product_mobile_content_one"
                                v-for="(content, index) in products[0].content" :key="index">{{content}}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="12">
                            <img :src="products[0].img[0].left" style="width: 100%;">
                        </el-col>
                        <el-col span="12">
                            <img :src="products[0].img[0].right" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">{{ products2[0].title }}</div>
                            <div class="product_font_style product_mobile_content_one"
                                v-for="(content, index) in products2[0].content" :key="index">{{ content }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="12">
                            <img :src="products2[0].img[0].left" style="width: 100%;">
                        </el-col>
                        <el-col span="12">
                            <img :src="products2[0].img[0].right" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="product_pc">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_pc_one">
                        <div class="product_mobile_title font_size_30">{{manages[0].title}}</div>
                        <div style="margin-top: 20px" class="product_font_style">{{manages[0].content[0]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[1]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[2]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[3]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[4]}}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <img :src="manages[0].img[0]" class="product_pc_img" />
                </el-col>
            </el-row>
        </div>
        <div id="产品特点" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                产品特点
            </div>
        </div>
        <div class="product_spec_parent">
            <div class="border_one border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[0].img" style="width: 50px;height: 50px" />
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[0].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[0].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[0].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img" />
            </div>
            <div class="border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[1].img" style="width: 50px;height: 50px" />
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[1].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[1].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[1].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img" />
            </div>
            <div class="border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[2].img" style="width: 50px;height: 50px" />
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[2].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[2].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[2].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img" />
            </div>
            <div class="border_spec" style="margin-right: 0">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[3].img" style="width: 50px;height: 50px" />
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[3].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[3].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[3].contents[1]}}
                    </div>
                </div>
            </div>
        </div>
        <div id="合作伙伴" class="cooperation head-label">
            <div style="text-align: center;" class="font_size_24">
                合作伙伴
            </div>
        </div>
        <div class="cooperation_parent">
            <div style="width: auto; height: auto; margin: auto">
                <img style="height: 160px;width: 160px;" src="../../static/other/partner_01.jpg" />
                <img style="height: 160px;width: 160px;margin-left: 30px;" src="../../static/other/partner_02.jpg" />
            </div>
        </div>
        <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p>
            </div>
        </div> -->

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                phoneType: 3,
                sliders: [],
                tabsList: ["保洁清洗系统","营销获客系统","信用体系保险系统","分佣零售系统","社区融合系统","异业合作系统","分账系统","多门店系统","在线签约系统","保姆月嫂系统","万能需求系统","智能派单系统","自营商城系统","二手回收系统","AI客服系统","培训系统","灵活用工管理系统","商户管理系统"],
                bgList: [
                    {
                        img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d269e927a15.png',
                        title: "获客难？",
                        content: '内置裂变式营销工具，客户主动帮你转介绍'
                    },
                    {
                        img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d265210aefd.png',
                        title: "管理累？",
                        content: '三端协同一键派单，手机就是移动办公室。'
                    },
                    {
                        img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d265375115d.png',
                        title: "形象弱？",
                        content: '零代码生成专业小程序，提升品牌信任。'
                    },
                    {
                        img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d265494becc.png',
                        title: "对账烦？",
                        content: '业务财务一体化，收支清晰利润一目了然。'
                    },
                ],
                images: [
                    {
                        img: require('../../static/other/用户管理.png'),
                        title: "用户管理",
                        content: ["用户消费分析", "用户标签设定"]
                    },
                    {
                        img: require('../../static/other/店铺管理.png'),
                        title: "社区网点",
                        content: ["以镇街为单位", "方便客户更快的享受服务"]
                    },
                    {
                        img: require('../../static/other/数据分析.png'),
                        title: "需求大厅",
                        content: ["发布自定义需求", "（后台审核）"]
                    }, {
                        img: require('../../static/other/用户构建.png'),
                        title: "安心码",
                        content: ["服务人员上门亮码", "让用户更安心"]
                    },
                    {
                        img: require('../../static/other/品牌渠道.png'),
                        title: "共富商城",
                        content: ["打造共富商城", "线上购买所需物品"]
                    }
                ],
                products: [
                    {
                        img: [
                            {
                                left: require('../../static/other/llh_c1.jpg'),
                                right: require('../../static/other/llh_c2.jpg'),
                            },
                            {
                                left: require('../../static/other/3.jpg'),
                                right: require('../../static/other/4.jpg'),
                            },
                            {
                                left: require('../../static/other/5.jpg'),
                                right: require('../../static/other/6.jpg'),
                            }
                        ],
                        title: "用户端展示，模块式布局，快速找到所需服务",
                        content: [
                            "服务分类分类细致，分类导航显示所有分类",
                            "热销项目优先排序 首页布局自定义",
                            "单品、多规格、属性、多价格展示",
                            "无需下载，打开微信即可使用"
                        ]
                    }
                ],
                products2: [
                    {
                        img: [
                            {
                                left: require('../../static/other/llh_b1.jpg'),
                                right: require('../../static/other/llh_b2.jpg'),
                            },
                            {
                                left: require('../../static/other/3.jpg'),
                                right: require('../../static/other/4.jpg'),
                            },
                            {
                                left: require('../../static/other/5.jpg'),
                                right: require('../../static/other/6.jpg'),
                            }
                        ],
                        title: "服务端展示，服务流程清晰",
                        content: [
                            "订单类型清晰，接单抢单更便捷",
                            "查看路线，可规划出当前位置到服务地点的最优路线",
                            "资金管理功能，更直观的展示订单与收入明细",
                            "无需下载，打开微信即可使用"
                        ]
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/llh_pc.jpg')],
                        title: "服务端+用户端一体化管理平台",
                        content: ["用户端小程序DIY布局 图片素材管理", "服务多规格自定义上架 分类自定义设置",
                            "用户管理 服务人员管理",
                            "统计并展示每天的用户量、订单量、营业额等",
                            "订单管理 实时掌握服务交易详情",
                            // "设置活动、红包、套餐卡等"
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "当家政",
                            contents: ["填写个人信息申请入驻", "成为家政服务人员"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "找家政",
                            contents: ["根据所需服务或指定阿姨", "可发布自定义需求"]
                        },
                        {
                            img: require('../../static/other/数据分析.png'),
                            title: "知家政",
                            contents: ["扫描服务人员的安心码", "查看服务人员的认证信息"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "评家政",
                            contents: ["对订单、平台或网点进行评价", "提出宝贵意见"]
                        }
                    ]
                },
                company: [
                    "企业从事于：互联网信息服务，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持。",
                    // "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                    "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                    "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
                ],
                carousel_height: '550px',
                pagesIndex: 0,
                pagesList: [
                    {
                        title: '会员管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ef470bc47.png'
                    },{
                        title: '服务人员管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ee6427233.png'
                    },{
                        title: '商户管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930eeb67cfbe.png'
                    },
                    // {
                    //     title: '异业机构管理',
                    //     url: ''
                    // },
                    {
                        title: '财务管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930edfd5aaed.png'
                    },{
                        title: '工单管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ee4c9888f.png'
                    },{
                        title: '营销管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ef2aa97a5.png'
                    },{
                        title: '商城管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930eeda940f8.png'
                    },{
                        title: '信用管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ef13c730e.png'
                    },{
                        title: '网点管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930eef59307d.png'
                    },
                    // {
                    //     title: '社区管理',
                    //     url: ''
                    // },
                    {
                        title: '培训管理',
                        url: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251204/6930ee81b4f17.png'
                    }
                ],
                companyList: ["浙江省商务厅","浙江省妇女联合会","杭州市商务局","沃尔玛","舟山市妇女联合会","杭州市家政服务协会","临安区商务局","平安车险","临安区妇女联合会","杭州市临安区家政服务行业协会"]
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251224/694b4ad467176.png'
                //    img: 'https://llhsh.zhelihao123.com/manage/public/upload/admin/20251114/6916db478fe3d.png'
                },
                // {
                //     img: 'https://llhjz.linan.gov.cn/attachs/photo/202404/20240429_BA9E1A6BA378E2E7A9DB548C87533BB3.png'
                // },
                // {
                //     img: 'https://llhjz.linan.gov.cn/attachs/photo/202404/20240429_CDFD506968E105BCF2B232D78555E7FC.png'
                // },
                // {
                //     img: 'https://llhjz.linan.gov.cn/attachs/photo/202404/20240429_EBFD1CC504D3304652B59E0578852043.png'
                // }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
        methods: {
            goInfo(){
                this.$router.push({name: "Infos"});
            }
        }
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 520px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {width: 75px;height: 55px;align-self: center}
    .font_size_24 {font-size: 1.5em;}
    .font_size_25{font-size: 2.3em;color: #333;}
    .font_size_26{font-size: 2.3em;color: #324148;margin: 10px 0;margin-bottom: 40px;font-weight: bold;text-align: center;}
    .font_size_27{font-size: 1.5em;color: #333;margin: 10px 0;margin-bottom: 40px;}
    .font_size_28{font-size: 2.2em;}
    .font_size_31{font-size: 1.4em;color: #324148;margin: 0px 0;margin-bottom: 20px;text-align: center;display: flex;justify-content: center;}
    .font_size_32{font-size: 0.8em;color: #fff;margin: 0 10px;background: #1773FF;padding: 3px 20px;border-radius: 5px;}
    .imgs{position: absolute;top: -10px;right: 80px;}
    .imgText{width: 19em;height: 24.6em;border-radius: 15px;background-repeat: no-repeat;background-size: 100% 100%;box-sizing: border-box;padding: 36px 25px;}
    .imgText_title{font-size: 2.1em;color: #1773FF;font-family: PingFangSC, PingFang SC;}
    .imgText_content{margin-top: 10px;color: #434A54;font-size: 1.3em;}
    .advantage{background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20250924/68d3425449576.png');background-repeat: no-repeat;background-size: 100% 100%;width: 100%;margin: 90px 0 80px 0;height: 500px;display: flex;align-items: center;color: #fff;box-sizing: border-box;}
    .advantage_left{text-align: center;width: 27%;}
    .advantage_right{width: 73%;}
    .ad_left1{font-size: 2.2em;}
    .ad_left2{font-size: 2.2em;}
    .ad_left3{width: 4em;margin-top: 1em;}
    .ad_right1{display: flex;align-items: center;justify-content: space-between;width: 88%;margin-left: 5%;}
    .ad_right2{width: 100%}
    .centers{width: 24%;display: flex;flex-direction: column;align-items: center;}
    .ad_right_text{font-size: 1.4em;color: #1773FF;background: #fff;padding: 10px 25px;border-radius: 30px;display: block;}
    .tabsBox{margin-top: 50px;width: 92%;margin-left: 4%;margin-bottom: 100px;}
    .tabsItem{width: 100%;display: flex;align-items: center;margin-bottom: 30px;}
    .tabsTitle{width: 15%;font-size: 2.5em;font-family: PingFangSC, PingFang SC;font-weight: 600;}
    .tabsInfo{display: flex;align-items: center;flex-wrap: wrap;width: 85%;}
    .tabs{font-size: 2em;font-weight: 400;padding: 10px 35px;border-radius: 10px;margin-right: 15px;background: #EDF4FF;margin-bottom:10px;}
    .phoneBox{margin-top: 50px;width: 100%;background: #EDF4FF;margin-bottom: 50px;}
    .phoneBox_title{color: #333333;font-size: 2.4em;display: flex;align-items: center;justify-content: center;gap: 80px;border-bottom: 1px solid #979797;}
    .phoneBox_title_text{padding: 40px 0;cursor: pointer;}
    .changeY{color: #1773FF;border-bottom: 5px solid #1773FF;}
    .phoneImgBox{display: flex;justify-content: center;align-items: center;gap: 80px;padding: 40px 0;}
    /* .phoneImgBox{display: flex;justify-content: space-around;align-items: center;padding: 40px 0;} */
    .phoneImg{width: 11em;margin-bottom: 20px;}
    .phoneCenters{text-align: center;font-size: 1.5em;}
    .staff_left{width: 55%;margin-top: 20px;}
    .staff_leftTop{background: #1773FF;color: #fff;padding: 40px 0 40px 170px;border-top-right-radius: 140px;border-bottom-right-radius: 140px;box-sizing: border-box;width: 100%;}
    .flex1{display: flex;align-items: center;margin-bottom: 20px;}
    .staff_icon{width: 2.3em;margin-right: 40px;}
    .staff_leftBottom{padding: 30px 0 0 170px;color: #1773FF;}
    .staff_right{margin-left: 80px;}
    .customerBox{margin: 80px 0;width: 100%;margin-bottom: 120px;}
    .customer_item{width: 36%;box-shadow: -1px 17px 27px 0px #F0F2F4;border-radius: 15px;text-align: center;padding: 30px 130px;box-sizing: border-box;}
    .customerTitle{font-size: 1.8em;margin-top: 55px;}
    .customerContent{font-size: 1.3em;margin-top: 30px;}
    .operationInfo{width: 92%;margin-left: 8%;height: 17em;margin-top: 50px;color: #fff;background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4b634ce6f5.png');background-repeat: no-repeat;background-size: 100% 100%;display: flex;align-items: center;justify-content: space-around;padding: 0 100px;box-sizing: border-box;}
    .operationTitle{font-size: 1.6em;margin: 20px 0;}
    .operationContent{font-size: 1.1em;}
    .cooperationBox{margin: 80px 0;width: 100%;}
    .tabss{color: #1773FF;background: #EDF4FF;padding: 15px 35px;border-radius: 10px;font-size: 2em;}
    .bottomBg{background: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4eaa6d1fed.png');background-repeat: no-repeat;background-size: 100% 100%;width: 100%;height: 15em;color: #fff;text-align: center;padding: 30px 0;box-sizing: border-box;}
    .bottomTitle{font-size: 2.2em;}
    .bottomContent{font-size: 1.2em;margin: 20px 0;}
    .bottomBtn{font-size: 1.1em;color: #1773FF;background: rgba(255,255,255,0.67);display: inline-block;padding: 10px 25px;border-radius: 10px;margin-top: 20px;cursor: pointer;}
    .topBox1{display: flex;align-items: center;justify-content: center;gap: 50px;}
    .topBox1_left{background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20251121/69200b70d6700.png');background-repeat: no-repeat;background-size: 100% 100%;padding: 30px 50px;width: 600px;box-sizing: border-box;color: #333333;}
    .topBox1_right{background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692ff15216fe6.png');background-repeat: no-repeat;background-size: 100% 100%;padding: 30px 50px;width: 600px;box-sizing: border-box;color: #F17C31;}
    .text1{font-size: 1.4em;font-weight: bold;}
    .text2{font-size: 1em;margin-top: 17px;display: flex;align-items: center;gap: 10px;}
    .text3{font-size: 1.4em;margin-top: 20px;font-weight: bold;color: #1773FF;}
    .text4{font-size: 1em;color: #333;}
    .topBox2{display: flex;justify-content: center;align-items: center;gap: 30px;}
    .topBox2_left{text-align: right;}
    .bgBox{width: 100%;background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20251126/6926abc482000.png');background-size: 100% 100%;background-repeat: no-repeat;padding: 70px 0;margin-bottom: 50px;}
    .bgBox_title{font-size: 2.4em;color: #fff;text-align: center;}
    .bgBox_tab{width: 55%;margin: 0 auto;margin-top: 80px;display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;}
    .tab_item{width: 30%;background: #fff;border-radius: 30px;padding: 10px 0;text-align: center;color: #333;font-size: 1.5em;margin-bottom: 30px;}
    .bgBlue{background: #1773FF;color: #fff;border-top-right-radius: 30px;border-bottom-right-radius: 30px;display: flex;align-items: center;width: 75%;margin: 0 auto;justify-content: space-between;margin-top: 50px;}
    .bgBlue_item{flex: 1;text-align: center;font-size: 1.4em;padding: 15px 0;border-top-right-radius: 30px;border-bottom-right-radius: 30px;border-right: 2px solid #fff;}
    .imgFlex{display: flex;flex-wrap: wrap;align-items: center;justify-content: center;gap:50px;margin-top: 50px;}
    .imgFlex_item{width: 14%;text-align: center;font-size: 24px;}
    .imgFlex_item_img{width: 100%;margin-bottom: 10px;}
    .bottomFlex{background: #EDF4FF;color: #1773FF;font-size: 1.3em;padding: 5px 20px;border-radius: 10px;}
    .phoneImgBox1{display: flex;justify-content: center;align-items: center;padding: 40px 0;}
    .phone_left{display: flex;flex-wrap: wrap;align-items: center;width: 500px;gap: 20px;}
    .phone_left_text{width: 200px;text-align: center;padding: 10px 0;background: #fff;border-radius: 5px;cursor: pointer;}
    .phone_left_text1{width: 200px;text-align: center;padding: 10px 0;background: linear-gradient( 270deg, #0F7DF0 0%, #2FBFFE 47%, #0E7BF0 100%);border-radius: 5px;color: #fff;cursor: pointer;}
</style>